import { Action } from '@ngrx/store';
import { FareFamiliesRequest, FareFamiliesResponse, FareFamily } from '@shared/models/fare-families.model';
import { FlightSearchPayload } from '@shared/models/flight-search-payload.model';
import {
  FlightSearchResponse,
  FlightSearchResponseAirline,
  FlightSearchResponseLocation,
} from '@shared/models/flight-search-response.model';
import { SelectedFlight } from '@shared/models/selected-flight.model';

export const CHECK_FLIGHTS_SEARCH_CANCEL = '[Travel Flights Search] Cancel search';

export const CREATE_FLIGHTS_SEARCH = '[Travel Flights Search] Create flights search';

export const GET_FLIGHT_SEARCH_RESULTS = '[Travel Flight Search] Get flight search results';
export const GET_FLIGHT_SEARCH_RESULTS_SUCCESS = '[Travel Flight Search] Get flight search results success';
export const GET_FLIGHT_SEARCH_RESULTS_FAILURE = '[Travel Flight Search] Get flight search results failure';

export const FILTER_FLIGHT_SEARCH_RESULTS = '[Travel Flight Search] Filter flight search results';

export const SELECT_FLIGHT = '[Travel Flight Search] Select flight';
export const CLEAR_SELECTED_FLIGHT_BOOKING_TOKEN = '[Travel Flights Search] Clear selected flight booking token';
export const CLEAR_SELECTED_FLIGHT = '[Travel Flights Search] Clear selected flight';

export const CLEAR_FLIGHTS_SEARCH = '[Travel Flights Search] Clear flights search';

export const RESTORE_FLIGHTS = '[Travel Flights Search] Restore flights';
export const RESTORE_FLIGHTS_SUCCESS = '[Travel Flights Search] Restore flights success';

export const GET_FLIGHT_FARE_FAMILIES = '[Travel Flight Search] Get flight fare families';
export const GET_FLIGHT_FARE_FAMILIES_SUCCESS = '[Travel Flight Search] Get flight fare families success';
export const CLEAR_FLIGHT_FARE_FAMILIES = '[Travel Flight Search] Clear flight fare families';
export const SELECT_FLIGHT_FARE_FAMILY = '[Travel Flight Search] Select flight fare families';

export const NAVIGATE_FROM_TRAVEL_SEARCH_PAGE = '[Travel Flight Search] Navigate from travel search page';

export class NavigateFromTravelSearchPage implements Action {
  readonly type = NAVIGATE_FROM_TRAVEL_SEARCH_PAGE;
  constructor(public payload: boolean) {}
}

export class ClearFlightsSearch implements Action {
  readonly type = CLEAR_FLIGHTS_SEARCH;
}

export class CreateFlightsSearch implements Action {
  readonly type = CREATE_FLIGHTS_SEARCH;
  constructor(public payload: FlightSearchPayload) {}
}

export class GetFlightSearchResults implements Action {
  readonly type = GET_FLIGHT_SEARCH_RESULTS;
  constructor(public payload: FlightSearchPayload) {}
}

export class GetFlightSearchResultsSuccess implements Action {
  readonly type = GET_FLIGHT_SEARCH_RESULTS_SUCCESS;
  constructor(public payload: FlightSearchResponse) {}
}

export class GetFlightSearchResultsFailure implements Action {
  readonly type = GET_FLIGHT_SEARCH_RESULTS_FAILURE;
  constructor(public payload: any) {}
}

export class FilterFlightSearchResults implements Action {
  readonly type = FILTER_FLIGHT_SEARCH_RESULTS;
  constructor(public payload: Array<{ name: string; value: any }>) {}
}

export class SelectFlight implements Action {
  readonly type = SELECT_FLIGHT;
  constructor(public payload: SelectedFlight) {}
}

export class CancelFlightsSearch implements Action {
  readonly type = CHECK_FLIGHTS_SEARCH_CANCEL;
}

export class RestoreFlights implements Action {
  readonly type = RESTORE_FLIGHTS;
}

export class RestoreFlightsSuccess implements Action {
  readonly type = RESTORE_FLIGHTS_SUCCESS;
  constructor(
    public payload: {
      selectedFlight: SelectedFlight;
      search: FlightSearchPayload;
      airlines: FlightSearchResponseAirline[];
      locations: FlightSearchResponseLocation[];
      searchReferenceId: string;
      selectedFareFamily: FareFamily;
    }
  ) {}
}

export class SelectFlightFareFamily implements Action {
  readonly type = SELECT_FLIGHT_FARE_FAMILY;
  constructor(public payload: FareFamily) {}
}

export class GetFlightFareFamilies implements Action {
  readonly type = GET_FLIGHT_FARE_FAMILIES;
  constructor(public payload: FareFamiliesRequest) {}
}

export class GetFlightFareFamiliesSuccess implements Action {
  readonly type = GET_FLIGHT_FARE_FAMILIES_SUCCESS;
  constructor(public payload: FareFamiliesResponse) {}
}

export class ClearFlightFareFamilies implements Action {
  readonly type = CLEAR_FLIGHT_FARE_FAMILIES;
}

export class ClearSelectedFlightBookingToken implements Action {
  readonly type = CLEAR_SELECTED_FLIGHT_BOOKING_TOKEN;
}

export class ClearSelectedFlight implements Action {
  readonly type = CLEAR_SELECTED_FLIGHT;
}

export type FlightsSearchActions =
  | ClearFlightsSearch
  | CreateFlightsSearch
  | GetFlightSearchResults
  | GetFlightSearchResultsSuccess
  | GetFlightSearchResultsFailure
  | FilterFlightSearchResults
  | SelectFlight
  | CancelFlightsSearch
  | RestoreFlights
  | RestoreFlightsSuccess
  | SelectFlightFareFamily
  | GetFlightFareFamilies
  | GetFlightFareFamiliesSuccess
  | ClearSelectedFlightBookingToken
  | ClearSelectedFlight
  | ClearFlightFareFamilies
  | NavigateFromTravelSearchPage;
